<!-- 活动规则 -->
<template>
  <div class="card-list">
    <template v-if="noOpen && !loading">
      <div class="img-box">
        <img :src="addCard" alt="">
      </div>
      <div class="add-text">
        添加您的常用的银行卡信息即可收到您的奖励金款项
      </div>
      <div class="add-card-btn" @click="add">
        +添加银行卡
      </div>
    </template>
    <template  v-if="!noOpen && !loading">
      <div class="card-box">
        <div class="card-detail" @click="add">
          <div>
            <div class="bank">{{detail.bankName}}</div>
            <div class="card-type">储蓄卡</div>
          </div>
          <div class="card-number">{{maskBankCardNumber(detail.bankCard)}}</div>
        </div>
        <div class="tips">*说明：必须添加本人名下借记卡，最多可添加一张银行卡</div>
        <div class="contact">
          <p>如需修改绑定的银行卡信息，</p>
          <p>可联系我们的官方运营伙伴 +400 859 9576</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import addCard from '@/assets/images/settle/addCard.png'
import { apiGet } from '@/services'
export default {
  name: 'addCard',
  data() {
    return {
      addCard,
      loading: true,
      noOpen: true, // 没开卡
      detail: {}
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    maskBankCardNumber(cardNumber) {
      const lastFourDigits = cardNumber.slice(-4)
      const maskedPart = '*'.repeat(cardNumber.length - 4)
      let maskedCardNumber = ''
      for (let i = 0; i < maskedPart.length; i++) {
          if (i > 0 && i % 4 === 0) {
              maskedCardNumber += ' '
          }
          maskedCardNumber += maskedPart[i]
      }
      maskedCardNumber += ' ' + lastFourDigits
      return maskedCardNumber.trim()
    },
    getDetail() {
      this.$loading()
      this.loading = true
      apiGet('partner/open/information/')
      .then(res => {
        if (res.code === '0000') {
          this.detail = {...res.data}
          // ("0没卡 1有卡")
          this.noOpen = !res.data.status
        } else {
          this.$notify.error(res.msg)
        }
      }).finally(() => {
        this.loading = false
        this.$clearLoading()
      })
    },
    add() {
      this.$router.push({
        path: '/settle'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.card-list{
  padding-top: 64px;
}
.img-box{
  width: 142px;
  height: 146px;
  margin: 0 auto;
  img{
    width: 100%;
    height: auto;
  }
}
.add-text{
  width: 146px;
  text-align: center;
  margin: 0 auto;
  margin-top: 24px;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
}
.add-card-btn{
  border: 1px dashed #5c288d;
  border-radius: 12px;
  height: 50px;
  margin: 0 auto;
  margin-top: 72px;
  width: calc(100vw - 32px);
  line-height: 50px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #5c288d;
}
.card-box{
  padding: 0 27px;
  .tips{
    margin-top: 30px;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
  }
  .contact{
    margin-top: 30px;
    text-align: center;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
  }
}
.card-detail{
  height: 120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px 18px 11px 18px;
  background: url(~@/assets/images/settle/cardMngBg.png) no-repeat;
  background-size: 100% auto;
  border-radius: 12px;
  color: #302B3E;
  box-sizing: border-box;
  .bank{
    font-size: 16px;
    font-weight: 600;
    line-height: 20px
  }
  .card-type{
    font-size: 10px;
    line-height: 14px;
    margin-top: 3px;
  }
  .type{
   font-size: 10px;
   line-height: 14px;
  }
  .card-number{
    font-size: 16px;
    font-weight: 600;
    line-height: 20px
  }
}
</style>
